<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeReservationType
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeReservationTypeProps } from '../types/interfaces'

import { useBadgeReservationType } from '../composables/use-badge-reservation-type.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeReservationType',
})

const props = defineProps<BadgeReservationTypeProps>()

const {
  color,
  text,
} = useBadgeReservationType({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
